import { Avatar, Button, Flex } from 'antd';
import { isMobileScreenSize, validateImageURL } from 'utils/helpers';
import NoImage from 'assets/no-image.png';
import { ArrowRightOutlined } from '@ant-design/icons';

type ClickableFirstColProps = {
  avatarUrl?: string;
  value?: string;
};

const ClickableFirstCol = ({ avatarUrl, value }: ClickableFirstColProps) => (
  <Flex align="center" justify="space-between" gap={4}>
    {!!avatarUrl && (
      <Flex align="center" gap={8}>
        <Avatar src={validateImageURL(avatarUrl) ? avatarUrl : NoImage} />
      </Flex>
    )}
    <div className="first-column-text">{value}</div>

    {!isMobileScreenSize ? (
      <Button className="table-click-indicator" type="text">
        <ArrowRightOutlined />
      </Button>
    ) : null}
  </Flex>
);

export default ClickableFirstCol;
